export default __webpack_public_path__ + "static/huiliang2-30a9a69e7f3085fedeaa92188396edbd.jpg";